import React, { useCallback, useEffect, useState } from "react";
import Logo from "assets/logo.svg";
import { fetchSites, ISite } from "services/site";
import { Tag, Avatar, Button, Divider, Dropdown, Menu } from "antd";
import { useSelector } from "react-redux";

import { formatDateTime } from "utils/dateTime";

import { useHistory } from "react-router-dom";

import routes from "constants/routes";
import { Header, Container, Content, SiteCard } from "./EnrollmentView.styles";
import { getJumpingPath } from "utils/navigation";
import { ControlOutlined, LogoutOutlined } from "@ant-design/icons";
import { useLogout } from "views/hooks";

const EnrollmentView: React.FC = () => {
  const [sites, setSites] = useState<ISite[]>([]);

  const history = useHistory();

  const userInfo = useSelector((state: any) => state.user.userInfo);

  useEffect(() => {
    fetchSites().then(({ join, own }) => {
      const mergedSites = [
        ...join,
        ...own.map((site) => ({
          ...site,
          isOwned: true,
        })),
      ];
      setSites(mergedSites);
    });
  }, []);

  const onSelectSite = useCallback(
    (site) => {
      history.push(getJumpingPath(site.id));
    },
    [history]
  );

  const handleAddStation = useCallback(() => {
    history.push(routes.ADMIN_ADD_STATION);
  }, [history]);
  const handleLogout = useLogout();


  const handleMenuClick = useCallback(
    ({ key }) => {
      switch (key) {
        case "logout":
          handleLogout();
          break;
        case "admin":
          history.push(routes.ADMIN);
          break;
        default:
          break;
      }
    },
    [handleLogout, history]
  );

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="admin">
        <ControlOutlined />
        系统管理
      </Menu.Item>
      <Menu.Item key="logout">
        <LogoutOutlined />
        退出登录
      </Menu.Item>
    </Menu>
  );

  return (
    <Container>
      <Header>
        <img src={Logo} alt="log" />
        <h1>选择站点</h1>
      </Header>
      <Content>
        <header>
          <div className="user">
            <Avatar size={40}>{userInfo.name}</Avatar>
            <div className="info">
              <div>{userInfo.name}</div>
              <div>{userInfo.email}</div>
            </div>
          </div>
          {userInfo?.isAdmin ? (
            <Dropdown.Button
              onClick={handleAddStation}
              type="primary"
              overlay={menu}
            >
              新建站点
            </Dropdown.Button>
          ) : (
            <Button onClick={handleLogout}>退出登录</Button>
          )}
        </header>
        <Divider />
        <section className="sites">
          {sites.map((site) => (
            <SiteCard
              onClick={() => onSelectSite(site)}
              size="small"
              key={site.id}
              title={site.name}
              hoverable
              extra={site.isOwned ? <Tag color="cyan">我的</Tag> : null}
            >
              <dl className="detail">
                <div className="detail-item">
                  <dt>创建时间：</dt>
                  <dd>{formatDateTime(site.createdAt)}</dd>
                </div>
                <div className="detail-item">
                  <dt>更新时间：</dt>
                  <dd>{formatDateTime(site.updatedAt)}</dd>
                </div>
              </dl>
            </SiteCard>
          ))}
        </section>
      </Content>
    </Container>
  );
};

export default EnrollmentView;
